<script>
export default {
  install(Vue) {
    Vue.$images = new function () {

      const getSrcset = function (image) {
        let srcset = "";
        if (image) {
          for (let i = 0; i < image.url.length; i++) {
            if (srcset.length != 0) {
              srcset += ", ";
            }
            const url = image.url[i];
            const imageSize = url.imageSize;
            srcset += url.url;
            if (imageSize.pixelDensity != 1.0) {
              srcset += " " + imageSize.pixelDensity + "x";
            }
          }
        }
        return srcset;
      };

      const getMedia = function (image) {
        let media = "";
        if (image) {
          const mediaSize = image.mediaSize;
          if (mediaSize.minWidth != null) {
            media += "(min-width: " + mediaSize.minWidth + "px)";
          }
          if (mediaSize.maxWidth != null) {
            if (mediaSize.minWidth != null) {
              media += " and ";
            }
            media += "(max-width: " + mediaSize.maxWidth + "px)";
          }
        }
        return media;
      };

      const getDefaultImageSrc = function (images) {
        let defaultUrl;
        if (images) {
          for (let i = 0; i < images.length; i++) {
            const image = images[i];
            for (let j = 0; j < image.url.length; j++) {
              const url = image.url[j];
              const imageSize = url.imageSize;
              if (!defaultUrl
                  || (defaultUrl.imageSize.pixelDensity != 1.0 && imageSize.pixelDensity == 1.0)
                  || (defaultUrl.imageSize.width * defaultUrl.imageSize.height < imageSize.width * imageSize.height) && imageSize.pixelDensity == 1.0) {
                defaultUrl = url;
              }
            }
          }
        }
        return defaultUrl?.url;
      }

      return {
        getSrcset,
        getMedia,
        getDefaultImageSrc
      }
    }
  }
}
</script>
